/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { usePortalSlice } from '../slice';
import { selectConnectedUser, selectCurrentProduct, selectIsConnectUserInProgress } from '../slice/selectors';
import { useEffect } from 'react';
import { chatActions } from '../../../containers/chat/slice';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
});
export default function useConnectUserHanlder() {
  const dispatch = useDispatch();
  const { actions } = usePortalSlice();
  const currentProduct = useSelector(selectCurrentProduct);
  const isLoading = useSelector(selectIsConnectUserInProgress);
  const connectedUser = useSelector(selectConnectedUser);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = (data: any) => {
    dispatch(actions.connectUser({ ...data, productId: currentProduct }));
  };
  useEffect(() => {
    if (connectedUser) {
      reset();
    }
    dispatch(chatActions.onNewChat());
  }, [connectedUser]);
  const handleDisconnect = () => {
    dispatch(actions.disconnectUser());
  };
  return { control, handleSubmit: handleSubmit(onSubmit), isLoading, connectedUser, handleDisconnect };
}
